import request from '@/modules/base/util/request'
import config from '@/config'
import miteConfig from '@/modules/apps/own/mite/config'
import lang from '@/lang'

import {
  updateItems,
  listLoading,
  listError,
  LIST_TYPES,
  updateData,
} from '@/redux/ducks/lists'

const { TRACKING_LIST_TYPE } = LIST_TYPES

export const setAppId = appId => updateData(TRACKING_LIST_TYPE, { appId })

const mutateTimeEntry = ({
  id,
  date_at: createdAt,
  customer_name: customerName,
  project_name: projectName,
  service_name: serviceName,
  hourly_rate: hourlyRate,
  note,
  minutes,
  revenue,
  locked,
}) => ({
  id,
  createdAt,
  customerName,
  projectName,
  serviceName,
  pricePerHour: hourlyRate / 100,
  note,
  minutes,
  hours: minutes ? `${parseInt(minutes / 60)}:${(minutes % 60).toString().padStart(2, '0')}` : minutes,
  revenue: revenue / 100,
  locked: lang.mite.lockedStatus[locked],
})

export const fetchingTrackings = appId => {
  return dispatch => {
    dispatch(listLoading(TRACKING_LIST_TYPE))

    request(miteConfig.endpoints.entries(appId), { auth: true, isConcurrent: true })
      .then(({ body: { data: { timeEntries }, meta } }) => {
        const items = timeEntries.map(t => mutateTimeEntry(t.time_entry))
        dispatch(updateItems(TRACKING_LIST_TYPE, items, meta))
      })
      .catch(({ body: { meta: error } }) => {
        dispatch(listError(TRACKING_LIST_TYPE, error))
      })
  }
}

export const lockTracking = (appId, id) => {
  return dispatch => {
    request(miteConfig.endpoints.lockItem(appId, id), { auth: true, isConcurrent: true, method: 'PUT', timeout: config.requestExtraLongTimeout })
      .then(() => {
        dispatch(fetchingTrackings(appId))
      })
      .catch(error => {
        console.error(error)
      })
  }
}
